import { useEffect, useState } from "react";
import { connect } from "react-redux";
import useMedia from "use-media";

import { CheckboxInstitutionForm } from "../molecules/checkboxInstitutionForm";
import { CourseCount } from "../molecules/courseCount";

const AreaAndFacilitySelectionContainer = (props) => {
    const { course, setCourse, state, onClickOpenSelectAreaWindow } = props;

    const useMediaFlag = useMedia({maxWidth:'480px'});
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [courseCount, setCourseCount] = useState(4)

    useEffect(() => {
        if(useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        let count = 0;
        for (let i in course) {
            if (course[i].checked === true) {
                count += 1;
            }
        }
        setCourseCount(count);

        course.forEach((c)=>{
            document.getElementById(c.value).checked = c.checked;
        });

        //表示施設のソート処理
        course.sort(function(first,second){
            if (first.facilitySort > second.facilitySort){
                return 1;
            }else if (first.sortNum < second.sortNum){
                return -1;
            }else{
                return 0;
            }
        })
        setCourse(course);
        console.log("ソート後のコース");
        console.log(course)

    }, [state]);

    // 選択した施設をstoreに保存
    const onClickDecision = () => {
        const arry = [];
        const elements = document.getElementsByClassName("area_course");
        for (let i in elements) {
            if (elements[i].checked === true) {
                arry.push(elements[i].value);
            }
        }

        for (let i in course) {
            let index = arry.indexOf(course[i].id);
            if (index >= 0) {
                course[i].checked = true;
            } else {
                course[i].checked = false;
            }
        }
        setCourse(course);
        onClickOpenSelectAreaWindow();
    };

    const onChangeChecked = (e) => {
        let count = 0;
        const elements = document.getElementsByClassName("area_course");
        for (let i in elements) {
            if (elements[i].checked === true) count += 1;
        }

        document.getElementById("grundy").checked = count ? true : false;

        setCourseCount(count);
    }

    const onChangeFullChecked = (e) => {
        let count = 0;
        const flag = e.target.checked;
        const elements = document.getElementsByClassName("area_course");
        for (let i = 0; i < elements.length; i++) {
            elements[i].checked = flag;
        }
        for (let i in elements) {
            if (elements[i].checked === true) count += 1;
        }
        setCourseCount(count);
    };

    return (
        <div style={state ? style.popupIsShow : style.popup} id="js-popup">
            <div style={isMobilePhone ? style.popupInnerMobile : style.popupInner}>
                <div style={style.closeBtn} id="js-close-btn" onClick={onClickOpenSelectAreaWindow}>
                    <svg style={style.svg}>
                        <polyline stroke="#A5A5A5" strokeWidth="2px" points="0,0 20,20" fill="none" />
                        <polyline stroke="#A5A5A5" strokeWidth="2px" points="20,0 0,20" fill="none" />
                   </svg>
                </div>
                <h4 style={isMobilePhone ? style.popupInnerTextSp: style.popupInnerText}>ゴルフ場</h4>
                <div style={style.detailedConditionArea}>
                    <CheckboxInstitutionForm divStyle={isMobilePhone ? style.divStyleMobile : style.divStyle} 
                        labelAreaStyle={style.labelAreaStyle} 
                        title={"ゴルフ場"} 
                        data={course} 
                        checkAreaStyle={style.startTimeCheckAreaStyle}
                        checkAreaDetailStyle={style.checkAreaDetailStyle}
                        onChangeFullCheck={onChangeFullChecked}
                        onChange={onChangeChecked} />
                </div>
                <div style={isMobilePhone ? style.buttonAreaMobile : style.buttonArea}>
                    <CourseCount style={isMobilePhone ? style.courseCountMobile : style.courseCount} course={courseCount}/>
                    <button style={style.button} onClick={onClickDecision}>決 定</button>
                </div>
            </div>
            <div style={style.blackBackground} id="js-black-bg"></div>
        </div>
    );
};
const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "45%",
        backgroundColor: "#fff",
        zIndex: "2",
        height:"90%",
        overflowY:'scroll',
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
        height:"90%",
        overflowY:'scroll',
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom:"1px solid #eee",
        margin:0,
        padding:"20px 0px 20px 0px"
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    closeBtn: {
        position: "absolute",
        right: "10px",
        top: "0px",
        width: "50px",
        height: "50px",
        lineHeight: "50px",
        textAlign: "center",
        cursor: "pointer",
        fontSize: "50px",
        color: "#A5A5A5",
    },    
    svg:{
        height: "20",
        width: "20",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    detailedConditionArea: {
        backgroundColor: "#fff",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        width: "100%",
        marginBottom: "20px",
    },
    courseCount: {
        margin: "30px 0 10px 0",
    },
    courseCountMobile: {
        margin: "10px 0",
    },
    // CheckboxListBoxコンポーネントに引数として渡すスタイル情報
    divStyle: {
        display: "flex",
        flexWrap: "wrap",
        width: "45%",
        textAlign: "left",
        alignContent: "flex-start",
        margin: "0 30px",
    },
    divStyleMobile: {
        display: "flex",
        flexWrap: "wrap",
        width: "80%",
        textAlign: "left",
        alignContent: "flex-start",
    },
    labelAreaStyle: {
        color: "#696969",
        width: "100%",
        borderBottom: "solid 1px #696969",
        marginTop: "15px", 
        marginBottom: "15px",
        fontSize: "small",
    },
    // エリアの各チェックボックス要素の並び(2列)
    areaStyleCheckArea: {
        width: "30%",
        paddingBottom: "15px",
    },
    // ゴルフ場の各チェックボックス要素の並び(1列)
    startTimeCheckAreaStyle: {
        width: "100%",
        paddingBottom: "15px",
        fontSize: "small",
    },
    checkAreaDetailStyle: {
        width: "100%",
        paddingLeft: "15px",
        paddingBottom: "15px",
        fontSize: "small",
    },
    buttonArea: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        paddingBottom: "40px",
    },
    buttonAreaMobile: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        marginBottom: "15px",
    },
    button: {
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        fontSize: "small",
        cursor: "pointer",
    },
}

const mapStateToProps = (state) => {
    return {
        course: state.course,
    };
};

const mapDisptchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        }
    };
};

export default connect(mapStateToProps, mapDisptchToProps)(AreaAndFacilitySelectionContainer);